import React from 'react';
import { Header } from 'semantic-ui-react';
import { OnHoverOnClick, Table } from 'dyl-components';
import { StringUtils } from 'utils';
import HoverContent from 'shared/hoverContent';
import Avatar from 'react-avatar';
import './HistoryColumns.scss';

const HistoryColumns = ({ activity }) => {
    const user = activity.user;
    const userName = user ? `${user.first_name} ${user.last_name}` : "Unknown Name";
    const status = (() => {
        const activity_event = activity.activity_event;
        if (activity_event === "added" || activity_event === "reactivated") {
            return "success";
        } else if (activity_event === "refreshed") {
            return "warning";
        } else if (activity_event === "removed" || activity_event === "expired") {
            return "error";
        }
        return null;
    })();
    return (
        <React.Fragment>
            <Table.Cell>
                <Header as='h4' className={`Activity__type`}>
                    {StringUtils.capitalize(activity.activity_type)}
                    <Header.Subheader className={`Activity__event${status ? ` Activity__event--${status}` : ""}`}>
                        <span>
                            {StringUtils.capitalize(activity.activity_event)}
                        </span>
                    </Header.Subheader>
                </Header>
            </Table.Cell>
            <Table.Cell>
                {activity.activity_description}
            </Table.Cell>
            <Table.Cell>
                {activity.user &&
                    (
                        <OnHoverOnClick
                            hoverContent={<HoverContent
                                user={user} />}
                            clickable={false}
                            trigger={<Avatar 
                                name={userName}
                                round
                                size='3em'
                            />} />
                    )}
            </Table.Cell>
        </React.Fragment>
    );
};

export default HistoryColumns;
